<div class="card mb-4">
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Caminho</th>
          <th>Descrição</th>
          <th class="text-right">Ações</th>
        </tr>
      </thead>
      <tbody *ngIf="tableLoading">
        <tr>
          <td colspan="5">
            <div class="p-5 d-flex justify-content-center position-relative">
              <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!tableLoading">
        <tr *ngIf="listaDadosSaida.length==0">
          <td class="text-center py-5 text-secondary w-500" colspan="7">
            Sem registros
          </td>
        </tr>
        <tr *ngFor="let c of listaDadosSaida">
          <td>{{ c.nome | uppercase }}</td>
          <td>{{ c.caminho | uppercase }}</td>
          <td>{{ c.descricao | uppercase }}</td>
          <td class="py-1">
            <div class="d-flex align-items-center justify-content-end">
              <span data-toggle="tooltip" data-placement="bottom" title="Editar">
              <button (click)="editDadoSaida(c.id)" class="btn btn-sm btn-icon btn-primary" title="EDITAR">
                <i class="mdi mdi-pencil"></i>
              </button></span>
              
              <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
              <button (click)="delDadoSaida(c.id)" class="btn btn-sm btn-danger btn-icon mx-1" title="DELETAR">
                <i class="mdi mdi-delete"></i>
              </button></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="card-footer bg-white row justify-content-between">
    <div class="mt-2 mt-md-0">
      <ngb-pagination [pageSize]="filter.per_page" [boundaryLinks]="true" [collectionSize]="total" [(page)]="filter.page" (pageChange)="nextPage()" [maxSize]="5" [rotate]="true">
      </ngb-pagination>
    </div>
    <div class="btn-group mt-2 mt-md-0" role="group" aria-label="Basic example">
      <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  filter.per_page==10}" type="button" class="btn btn-outline-primary">10</button>
      <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  filter.per_page==25}" type="button" class="btn btn-outline-primary">25</button>
      <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  filter.per_page==50}" type="button" class="btn btn-outline-primary">50</button>
      <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':  filter.per_page==100}" type="button" class="btn btn-outline-primary">100</button>
    </div>
  </div>
</div>